export default "__VITE_ASSET__BEFJrn0N__"